<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="page-heading">
  <br>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/home"><em class="la la-home font-20"></em></a>
    </li>
    <li class="breadcrumb-item">
      <span i18n="@@myAccount">My account</span>
    </li>
  </ol>
</div>

<div class="page-content fade-in-up">
  <div class="jumbotron">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2 text-justify">
        <p i18n="@@profileInfo">For any modifications concerning your coordinates, please contact us at :</p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 text-justify">
        <app-display-contact [oneLine]="true"></app-display-contact>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2 text-justify">
        <p>
          <strong i18n="@@caution">Caution</strong>, <span i18n="@@profileChangesImpact">
            the change of password will cause the change on the following accounts
          </span>:
        </p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify">
        <app-display-third-parties></app-display-third-parties>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <div class="ibox">
        <div class="ibox-head">
          <div class="ibox-title" i18n="@@changePassword">Change password</div>
        </div>

        <div class="ibox-body">
          <form [formGroup]="passwordFG" #passwordForm="ngForm" (ngSubmit)="passwordFormSubmit()">


            <input type="text" style="display: none;" name="username"  class="form-control" autocomplete="username">

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
              <app-input-password controlName="oldPassword" i18n-label="@@passwordCurrent" label="Current password"
                                  [formGroup]="passwordFG" [onlyRequiredError]="true"
                                  [submitted]="passwordForm?.submitted"></app-input-password>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
              <app-input-password controlName="password" i18n-label="@@newPassword" label="New password"
                                  [formGroup]="passwordFG" [onlyRequiredError]="false"
                                  [submitted]="passwordForm?.submitted"></app-input-password>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-2">
              <app-input-password controlName="confirm" i18n-label="@@confirmPassword" label="Confirm password"
                                  [formGroup]="passwordFG" [onlyRequiredError]="false"
                                  [submitted]="passwordForm?.submitted"></app-input-password>
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <button class="btn btn-success btn-block btn-rounded text-uppercase" i18n="@@edit">Edit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
